import axios from "axios";
import BASE_URL from "../config/host";

export const postData = async (url, data, onUploadProgress) => {
  try {
    const instance = axios.create({
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    const res = await instance.post(url, data, { onUploadProgress });
    return res.data;
  } catch (error) {
    console.error("Upload Error Details:", error);
    let message = "Something went wrong. Please try again.";
    const errString = error?.toString() || "";
    if (error.code === "ERR_UPLOAD_FILE_CHANGED" || errString.includes("ERR_UPLOAD_FILE_CHANGED") || (error.code === "ERR_NETWORK" && error.message === "Network Error" &&
        url.includes("confirm-new-employee"))) {
      message = "The selected file changed during upload. Please reselect the file and try again.";
    } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
      message = "Network error — please check your internet connection.";
    } else if (error.response?.data?.message) {
      message = error.response.data.message;
    } else if (error.message) {
      message = error.message;
    }
    return { status: error?.response?.status || 400, message };
  }
};




// export const postData = async (url, data, onUploadProgress) => {
//   try {
//     const instance = axios.create({
//       baseURL: BASE_URL,
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       },
//     });

//     const res = await instance.post(url, data, {
//       onUploadProgress, // Track progress
//     });
//     return res.data;
//   } catch (error) {
//     return { status:  error?.response?.data?.status || 400, message: error?.response?.data?.message || error.message };
//   }
// };

export const apiRequest = async ({
  method,
  url,
  data = {},
  params = {},
  headers = {},
  useBaseUrl = true,
}) => {
  try {
    const baseURL = useBaseUrl ? BASE_URL : "";
    const accessToken = localStorage.getItem("accessToken");
    const instance = axios.create({
      baseURL,
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : "",
        ...headers,
      },
    });

    const response = await instance.request({
      method, // HTTP method (GET, POST, PUT, DELETE, etc.)
      url, // API endpoint
      data, // Body payload (for POST, PUT, PATCH)
      params, // Query parameters
    });

    return response.data;
  } catch (error) {
    return {
      status: error.response?.status || 400,
      message: error.response?.data?.message || error.message,
    };
  }
};
